// extracted by mini-css-extract-plugin
module.exports = {"kodiakLogo":"styles_kodiakLogo__1G4bS","bearLogo":"styles_bearLogo__2PsZf"};